module.exports={version:"0.1.0",settings:{enableStreaming:!0,project:"GP0xZjr0A22h5SyD2HsY5S5kEHoFoTN6"}};